export function addUuidToFilename(objectName: string): string {
  return crypto.randomUUID().toString().replaceAll('-', '') + '-' + objectName;
}
